import React from 'react'

const EHRCaseStudyHero = () => {
    return (
        <section className="lg:py-28 lg:px-12 px-5 sm:px-6 py-28 bg-bgDefault text-white overflow-x-hidden">
            <div className='container w-full max-w-full xl:mx-auto xl:max-w-screen-xl'>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-8 w-full min-w-0'>
                    <div className='min-w-0 max-w-full'>
                        <h2 className="text-[26px] leading-[34px] sm:text-heading-4 lg:text-heading-1 font-dmsans font-bold tracking-[-0.06em] mb-8 break-words max-w-full ">
                            Academic EHR Training Solution
                        </h2>
                         <div className="flex flex-wrap gap-2 mt-2 mb-6">
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Java
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Spring Boot
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                Angular
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                PostgreSQL
                            </span>
                            <span
                                className="text-[#9E9E9E] text-body-sm bg-[#2C2C2C] border border-[#494949] px-2 py-0.5"
                            >
                                AWS
                            </span>
                        </div>
                         <p className="text-[#9E9E9E] mb-6 text-base md:text-body font-roboto break-words max-w-full lg:px-0">
                              We partnered with a leading US Electronic Health Record (EHR) solution provider to revolutionize medical education
                              through an innovative academic EHR training platform. This cutting-edge system successfully simulates real-world
                              medical charting and patient management in a secure, controlled environment, empowering over 10,000 medical students,
                              faculties, and preceptors to master clinical workflows before entering actual healthcare settings. The platform has
                              become an essential bridge between classroom theory and clinical practice, reducing the learning curve by 30% and
                              facilitating 5,000+ online practical examinations with zero data breaches.
                            </p>

                    </div>
                    <div className='min-w-0 max-w-full'>
                      <img src='/case_studies/title-banner/ehr-app-title-banner.png' alt='Academic EHR Training Solution' className='w-full h-auto max-w-full'></img>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default EHRCaseStudyHero
